<template>
  <div flat class="align-start d-none d-lg-block">
    <div class="w-100 topbar bg-color-1 d-flex align-center">
      <v-container class="pa-0">
        <v-row class="d-flex">
            <v-col cols="5" class="pa-0 text-white d-flex justify-start align-center">
                <span class="d-none text-top-loja">Você está comprando on-line em:</span> <v-btn variant="text" class="font-weight-bold px-2" append-icon="mdi-chevron-down" @click="openStores()"><span class="market-name text-uppercase font-weight-bold" v-if="getConfig.storeConfig != null">{{ getConfig.storeConfig.store_name }}</span></v-btn>
            </v-col>
            <v-col cols="7" class="pa-0 d-flex justify-end align-center text-small">
                <!-- <a class="text-decoration-none text-white cursor-pointer">
                  <div class="d-flex align-center" @click="$router.push('/profile/pedidos')">
                    <Svgs :icon="'refazer'" :color="'fill-color-white'" :width="25" :height="25"></Svgs> 
                    <span class="ms-3">Refazer mesmo pedido</span>
                  </div>
                </a> -->
                
                <a href="" @click.prevent="$router.push('/institucional/comocomprar')" class="text-decoration-none text-white cursor-pointer ms-5 cy-appbar-comocomprar">Como Comprar</a>
                <a href="" @click.prevent="$router.push('/institucional/locaisehorarios')" class="text-decoration-none text-white cursor-pointer ms-5 cy-appbar-locais">Locais e Horários de Entrega</a>
                <a href="" @click.prevent="$router.push('/institucional/politicadetroca')" class="text-decoration-none text-white cursor-pointer ms-5 cy-appbar-politica">Política de Troca</a>
            </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="w-100 header d-flex align-center bg-white">
      <v-container class="pa-0">
        <v-row class="d-flex">
          <v-col cols="12" class="pa-0 d-flex justify-space-between align-center">
            <v-skeleton-loader :loading="logoImage == null" width="117" height="76" class="logo-supermercado">
              <v-img v-if="logoImage != 'no-image'" :src="logoImage" class="cursor-pointer me-3" alt="Logo" @click="$router.push('/')"></v-img>
              <v-img v-else src="@/assets/images/logo-supermercado.png" class="cursor-pointer me-3" alt="Logo" @click="$router.push('/')"></v-img>
            </v-skeleton-loader>
            <div class="mx-3" style="flex-grow: 1; max-width: 600px;">
              <Search></Search>
            </div>
            <v-skeleton-loader :loading="loadingUser" width="300" height="76">
              <v-btn append-icon="mdi-chevron-down" variant="text" class="btn-header mx-6" v-if="getConfig.isu > 0 && getSelectedAddress.street != null" @click="modelAddress = !modelAddress">
                <template v-slot:prepend>
                  <Svgs v-if="(getSelectedAddress.area != null && getSelectedAddress.destiny_type >= 1) || (getSelectedAddress.destiny_type == 0 && getConfig.storeConfig.min_withdrawal_value_order >= 0)" :icon="'pin'" :color="'fill-color-2'" :width="35" :height="35"></Svgs>
                  <v-tooltip v-else width="200" location="bottom" :text="getSelectedAddress.destiny_type >= 1 ? 'Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está' + ( getConfig.storeConfig.min_withdrawal_value_order >= 0 ? ' correto ou retire suas compras em nossa unidade.': ' correto.' ) : 'Infelizmente não efetuamos retirada nesta unidade. Por favor, altere para um endereço de entrega.'">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" icon="mdi-alert-outline" class="text-color-red" size="large"></v-icon>
                    </template>
                  </v-tooltip>
                </template>
                <div class="text-start text-color-0 text-small text-break btn-space">
                  <b v-if="getSelectedAddress.destiny_type == 2">Express:</b>
                  <b v-else-if="getSelectedAddress.destiny_type == 1">Entrega:</b>
                  <b v-else>Retirada:</b> 
                  {{ getSelectedAddress.street }}, {{ getSelectedAddress.num }}, {{ getSelectedAddress.district }} - {{ getSelectedAddress.city }}/{{ getSelectedAddress.state }}
                </div>
              </v-btn>
              <v-btn variant="text" class="btn-header mx-6" @click="openLogin()" v-else>
                <template v-slot:prepend>
                  <Svgs :icon="'pin'" :color="'fill-color-2'" :width="35" :height="35"></Svgs>
                </template>
                <div class="text-start text-color-0 text-small text-break">Adicionar local de <b>entrega</b> ou <b>retirada</b></div>
              </v-btn>
            </v-skeleton-loader>
            <v-skeleton-loader :loading="loadingUser" width="252" height="76" :class="loadingUser ? 'ms-6' : ''">
              <v-menu :location="'bottom'" class="mx-6" v-if="getConfig.isu > 0 && getUserInfo != null">
                <template v-slot:activator="{ props }">
                  <v-btn append-icon="mdi-chevron-down" variant="text" class="btn-header cy-appbar-profile" v-bind="props">
                    <template v-slot:prepend>
                      <Svgs :icon="'perfil'" :color="'fill-color-2'" :width="35" :height="35"></Svgs>
                    </template>
                    <div class="text-start text-color-0 text-small text-break btn-space">Olá, {{ getUserInfo.name }}</div>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="$router.push('/profile/cadastro')" class="cy-appbar-profile-cadastro">
                    <template v-slot:prepend>
                      <Svgs :icon="'perfil'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Meu Cadastro</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$router.push('/profile/pedidos')" class="cy-appbar-profile-pedidos">
                    <template v-slot:prepend>
                      <Svgs :icon="'carrinho'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Meus Pedidos</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$router.push('/profile/enderecos')" class="cy-appbar-profile-enderecos">
                    <template v-slot:prepend>
                      <Svgs :icon="'pin'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Meus Endereços</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="$router.push('/favoritos')" class="cy-appbar-profile-favoritos">
                    <template v-slot:prepend>
                      <v-icon :icon="'mdi-heart'" size="large" class="text-color-2 no-margin-inline"></v-icon>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Favoritos</v-list-item-title>
                  </v-list-item> -->
                  <v-list-item @click="$router.push('/profile/senha')" class="cy-appbar-profile-senha">
                    <template v-slot:prepend>
                      <Svgs :icon="'cadeado'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Alterar Senha</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="logoutDialog()" class="cy-appbar-profile-logout">
                    <template v-slot:prepend>
                      <Svgs :icon="'sair'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                    </template>
                    <v-list-item-title class="link-menu text-small ms-3">Sair</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn variant="text" class="btn-header cy-appbar-login" @click="openLogin()" v-else>
                <template v-slot:prepend>
                  <Svgs :icon="'perfil'" :color="'fill-color-2'" :width="35" :height="35"></Svgs>
                </template>
                <div class="text-start text-color-0 text-small text-break">Olá, faça seu <b>login</b> ou <b>cadastre-se</b></div>
              </v-btn>
            </v-skeleton-loader>
            <v-skeleton-loader :loading="loadingCart" width="125" height="65" :class="loadingCart ? 'ms-6' : ''">
              <v-badge :color="'var(--color-two)'" class="cursor-pointer" v-model="badge">
                <div tabindex="0" id="cart-button1" class="cart-button d-flex align-center justify-space-around px-4 ms-6" @click.stop="navDrawer('carrinho');" @keyup.enter="navDrawer('carrinho');">
                  <Svgs :icon="'carrinho'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                  <div class="text-center text-small">
                    {{ getTotalCart }}<br>
                    {{ getTotalCart > 1 ? 'itens': 'item' }}
                  </div>
                </div>
              </v-badge>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="w-100 menu d-flex align-center bg-white">
      <v-container class="pa-0">
        <v-row class="d-flex">
          <v-col v-if="!loadingTabs" class="pa-0 d-flex text-color-1 align-center justify-space-between">
            <v-btn @click.stop="navDrawer('menu');" variant="tonal" class="text-color-2 cy-appbar-departamentos" size="large">
              <v-icon icon="mdi-menu" size="small"></v-icon> Departamentos
            </v-btn> 
            <v-tabs :grow="true" :show-arrows="true" class="align-center">
              <v-btn size="large" :hide-slider="true" @click="$router.push('/offers/2')" variant="text" :class="2 == category_selected ? 'text-color-1': 'text-color-2'" v-if="getTabsClusterOffers != null && getTabsClusterOffers.length > 0">
                Ofertas
              </v-btn>
              <v-menu open-on-hover v-for="t in getCategories()" :hide-slider="true" v-bind:key="t.id">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" size="large" variant="text" :class="t.id.toString() == category_selected ? 'text-color-1': 'text-color-0'" @click="$router.push('/feed/'+t.id)" @mouseenter="getSubCategoriesMenu(t.id)">{{ capitalize(t.name) }}</v-btn>
                </template>
                <v-card v-if="t.subcategories != undefined">
                  <div class="d-flex flex-no-wrap justify-space-between align-center">
                    <img class="tab-img" v-if="t.image != undefined && t.image != '' && t.image != null && t.image != 'no-image'" :src="t.image" alt="Produto">
                    <v-list v-if="t.subcategories != undefined" class="my-0 py-0">
                      <v-list-item class="text-color-0 text-small pe-7" v-for="ts in t.subcategories.slice(0, 3)" :key="ts.id_subcategoria" @click="$router.push('/feed/'+t.id+'/'+ts.id_subcategoria)">
                        {{ capitalize(ts.nome_subcategoria) }}
                      </v-list-item>
                    </v-list>
                  </div>
                  <v-list v-if="t.subcategories.length > 3" class="my-0 py-0 br-0">
                    <v-list-item variant="tonal" density="comfortable" class="text-color-1 text-small text-center" @click="$router.push('/feed/'+t.id)">Ver mais</v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-tabs>
          </v-col>
          <v-col v-else class="pa-0 text-white d-flex align-center justify-space-between">
            <v-btn @click.stop="navDrawer('menu');" variant="tonal" class="text-color-2 cy-appbar-departamentos" size="large">
              <v-icon icon="mdi-menu" size="small"></v-icon> Departamentos
            </v-btn> 
            <v-skeleton-loader v-for="a in 6" v-bind:key="a" :loading="loadingTabs" width="135" height="20" :class="'ms-6'"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
  <div class="d-none bar-fixed bg-white border-bottom-color" :class="scrollPosition > 300 ? 'd-lg-block': ''">
    <v-container class="px-0">
      <v-row>
        <v-col cols="12" class="pa-0 d-flex justify-space-between align-center">
          <div class="d-flex align-center justify-start">
            <v-skeleton-loader :loading="logoImage == null" width="117" height="76" class="logo-supermercado">
              <v-img v-if="logoImage != 'no-image'" :src="logoImage" class="cursor-pointer me-3" alt="Logo" @click="$router.push('/')"></v-img>
              <v-img v-else src="@/assets/images/logo-supermercado.png" class="cursor-pointer me-3" alt="Logo" @click="$router.push('/')"></v-img>
            </v-skeleton-loader>          </div>
          <div class="mx-6 flex-grow-1" style="min-width: 0">
            <v-container>
              <v-row class="py-0">
                <v-col cols="12" class="py-2">
                  <Search :mobile="true"></Search>
                </v-col>
                <v-col cols="12" v-if="!loadingTabs" class="pa-0 d-flex text-color-1 align-center justify-start">
                  <v-btn @click.stop="navDrawer('menu');" variant="tonal" class="text-color-2">
                    <v-icon icon="mdi-menu" size="small"></v-icon> Departamentos
                  </v-btn>
                  <v-tabs :show-arrows="true" density="compact">
                    <v-tab :hide-slider="true" @click="$router.push('/offers/2')" variant="text" :class="2 == category_selected ? 'text-color-1': 'text-color-2'"  v-if="getTabsClusterOffers != null && getTabsClusterOffers.length > 0">
                      Ofertas
                    </v-tab>
                    <v-menu open-on-hover v-for="t in getCategories()" :hide-slider="true" v-bind:key="t.id">
                      <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" variant="text" :class="t.id.toString() == category_selected ? 'text-color-1': 'text-color-0'" @click="$router.push('/feed/'+t.id)" @mouseenter="getSubCategoriesMenu(t.id)">{{ capitalize(t.name) }}</v-btn>
                      </template>
                      <v-card v-if="t.subcategories != undefined">
                        <div class="d-flex flex-no-wrap justify-space-between align-center">
                          <img class="tab-img" v-if="t.image != undefined && t.image != '' && t.image != null && t.image != 'no-image'" :src="t.image" alt="Produto">
                          <v-list v-if="t.subcategories != undefined" class="my-0 py-0">
                            <v-list-item class="text-color-0 text-small pe-7" v-for="ts in t.subcategories.slice(0, 3)" :key="ts.id_subcategoria" @click="$router.push('/feed/'+t.id+'/'+ts.id_subcategoria)">
                              {{ capitalize(ts.nome_subcategoria) }}
                            </v-list-item>
                          </v-list>
                        </div>
                        <v-list v-if="t.subcategories.length > 3" class="my-0 py-0 br-0">
                          <v-list-item variant="tonal" density="comfortable" class="text-color-1 text-small text-center" @click="$router.push('/feed/'+t.id)">Ver mais</v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </v-tabs>
                </v-col>
                <v-col cols="12" v-else class="pa-0 text-white d-flex align-center justify-space-between">
                  <v-btn @click.stop="navDrawer('menu');" variant="text" class="text-color-2">
                    <v-icon icon="mdi-menu" size="small"></v-icon> Departamentos
                  </v-btn>
                  <v-skeleton-loader v-for="a in 9" v-bind:key="a" :loading="loadingTabs" width="135" height="20" :class="'ms-6'"></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div class="d-flex align-center justify-end">
            <v-skeleton-loader :loading="loadingCart" width="125" height="65">
              <v-badge :color="'var(--color-two)'" class="cursor-pointer" v-model="badge">
                <div id="cart-button2" class="cart-button d-flex align-center justify-space-around px-4" @click.stop="navDrawer('carrinho');">
                  <Svgs :icon="'carrinho'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
                  <div class="text-center text-small">
                    {{ getTotalCart }}<br>
                    {{ getTotalCart > 1 ? 'itens': 'item' }}
                  </div>
                </div>
              </v-badge>
            </v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div flat class="align-start d-block d-lg-none top-mobile">
    <v-row class="pa-0 ma-0 bg-color-1">
      <v-col cols="2" class="d-flex align-center justify-center">
        <v-icon icon="mdi-menu" color="#fff" @click.stop="navDrawer('menu');"></v-icon>
      </v-col>
      <v-col cols="8" class="d-flex align-center justify-center cursor-pointer text-color-white" @click="openStores()">
        <v-skeleton-loader :loading="getConfig.storeConfig == null" type="text" width="100%" class="bg-color-1">
          <b class="market-name" v-if="getConfig.storeConfig != null">{{ getConfig.storeConfig.store_name }}</b> <v-icon icon="mdi-chevron-down"></v-icon>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="2" class="d-flex align-center justify-center">
        <v-menu :location="'bottom'" class="mx-6" v-if="getConfig.isu > 0 && getUserInfo != null">
          <template v-slot:activator="{ props }">
            <v-btn variant="text" class="icon-menu cy-appbar-profile-mobile" v-bind="props">
              <template v-slot:prepend>
                <Svgs :icon="'perfil'" :color="'fill-color-white'" :width="30" :height="30"></Svgs>
              </template>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$router.push('/profile/cadastro')">
              <template v-slot:prepend>
                <Svgs :icon="'perfil'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
              </template>
              <v-list-item-title class="link-menu ms-3">Meu Cadastro</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/profile/pedidos')">
              <template v-slot:prepend>
                <Svgs :icon="'carrinho'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
              </template>
              <v-list-item-title class="link-menu ms-3">Meus Pedidos</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/profile/enderecos')">
              <template v-slot:prepend>
                <Svgs :icon="'pin'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
              </template>
              <v-list-item-title class="link-menu ms-3">Meus Endereços</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item @click="$router.push('/favoritos')">
              <template v-slot:prepend>
                <v-icon :icon="'mdi-heart'" size="large" class="text-color-2 no-margin-inline"></v-icon>
              </template>
              <v-list-item-title class="link-menu ms-3">Favoritos</v-list-item-title>
            </v-list-item> -->
            <v-list-item @click="$router.push('/profile/senha')">
              <template v-slot:prepend>
                <Svgs :icon="'cadeado'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
              </template>
              <v-list-item-title class="link-menu ms-3">Alterar Senha</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logoutDialog()" class="cy-appbar-profile-mobile-logout">
              <template v-slot:prepend>
                <Svgs :icon="'sair'" :color="'fill-color-2'" :width="30" :height="30"></Svgs>
              </template>
              <v-list-item-title class="link-menu ms-3">Sair</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="cursor-pointer line-0" @click="openLogin()" v-else>
          <Svgs :icon="'perfil'" :color="'fill-color-white'" :width="30" :height="30"></Svgs>
        </div>
      </v-col>
    </v-row>
    <v-row class="py-0 px-2 ma-0 bg-color-1">
      <Search :mobile="true"></Search>
    </v-row>
    <v-row v-if="loadingUser" class="pa-0 ma-0 bg-color-1">
      <v-col class="pa-2">
        <v-skeleton-loader type="text" width="100%" class="bg-color-1"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-else class="pa-0 ma-0 bg-color-1">
      <v-col cols="8" v-if="getConfig.isu > 0 && getSelectedAddress.street != null" class="d-flex align-center justify-start text-color-white text-xsmall pa-1 cursor-pointer" @click="modelAddress = !modelAddress">
        <b v-if="getSelectedAddress.destiny_type == 2">Express:</b>
        <b v-else-if="getSelectedAddress.destiny_type == 1">Entrega:</b>
        <b v-else>Retirada:</b> 
        <div class="bar-address">
          <span class="ms-2" >{{ getSelectedAddress.street }}, {{ getSelectedAddress.num }}</span>
        </div>
      </v-col>
      <v-col cols="8" v-else class="d-flex align-center justify-start text-color-white text-small pa-1 cursor-pointer"></v-col>
      <v-col cols="4" class="d-flex align-center justify-end text-color-white text-xsmall pa-1 cursor-pointer" @click="openDialogAddress()">
        <b class="me-2 text-nowrap">Ver horários</b> <Svgs :icon="'relogio'" :color="'fill-color-white'" :width="20" :height="20"></Svgs> <v-icon icon="mdi-chevron-down" size="small" class="ms-1"></v-icon>
      </v-col>
    </v-row>
  </div>
  <div flat class="align-start d-block d-lg-none footer-mobile">
    <v-row class="pa-0 ma-0 text-color-black bg-color-gray border-top">
      <v-col cols="8" class="py-2 d-flex align-center justify-start">
        <Svgs :icon="'carrinho'" :color="'fill-color-1'" :width="20" :height="20"></Svgs>
        <b class="text-small text-bold ms-2">TOTAL COMPRAS ({{ getTotalCart }})</b>
      </v-col>
      <v-col cols="4" class="py-2 d-flex align-center justify-end">
        <v-skeleton-loader :loading="loadingCart" type="text" width="60" class="bg-color-gray">
          <b class="text-small text-bold">{{ $formatNumber(getTotalValueCart, {style: 'currency', currency: 'BRL'}) }}</b>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="px-0 ma-0 bg-color-1 pb-3 pt-1">
      <v-col class="d-flex align-center justify-center cursor-pointer flex-wrap pa-2" @click="$router.push('/')">
        <Svgs :icon="link == 'offers' || link == 'feed' ? 'houseon': 'house'" :color="'fill-color-white'" :width="25" :height="25"></Svgs>
        <span class="w-100 text-xsmall text-color-white text-center mt-2">Início</span>
      </v-col>
      <v-col class="d-flex align-center justify-center cursor-pointer flex-wrap pa-2" @click="$router.push('/services/lembretes')">
        <Svgs :icon="link == 'lembretes' ? 'lembreteon': 'lembrete'" :color="'fill-color-white'" :width="25" :height="25"></Svgs>
        <span class="w-100 text-xsmall text-color-white text-center mt-2">Lembretes</span>
      </v-col>
      <v-col class="d-flex align-center justify-center cursor-pointer flex-wrap pa-2" @click="$router.push('/services/folhetos')">
        <Svgs :icon="link == 'folhetos' ? 'folhetoon': 'folheto'" :color="'fill-color-white'" :width="25" :height="25"></Svgs>
        <span class="w-100 text-xsmall text-color-white text-center mt-2">Folhetos</span>
      </v-col>
      <v-col class="d-flex align-center justify-center cursor-pointer flex-wrap pa-2" @click="navDrawer('carrinho');">
        <v-badge id="cart-button-mobile" color="#f0760f" text-color="#fff" v-model="badge" :content="getTotalCart">
          <Svgs :icon="'carrinho'" :color="'fill-color-white'" :width="25" :height="25"></Svgs>
        </v-badge>
        <span class="w-100 text-xsmall text-color-white text-center mt-2">Carrinho</span>
      </v-col>
      <v-col class="d-flex align-center justify-center cursor-pointer flex-wrap pa-2" @click="$router.push('/moreinfo')">
        <Svgs :icon="link == 'moreinfo' ? 'opcoeson': 'opcoes'" :color="'fill-color-white'" :width="25" :height="25"></Svgs>
        <span class="w-100 text-xsmall text-color-white text-center mt-2">Mais</span>
      </v-col>
    </v-row>
  </div>
  <Menu :recolher="recolher" :drawer="drawerMenu"></Menu>
  <Cart :recolher="recolher" :drawer="drawerCarrinho"></Cart>
  <DialogAddress :fechar="fechar" :model="modelAddress" :startIsEntrega="startIsEntrega" :startPage="startPage"></DialogAddress>
  <DialogAddressRegister :fechar="fecharAddressRegister"  :model="modelAddressRegister" :address="address" :register="null" :confirm="true"></DialogAddressRegister>
</template>

<script>
import Menu from '@/components/Menu.vue';
import Search from '@/components/Search.vue';
import Cart from '@/components/Cart.vue';
import Svgs from '@/components/Svgs.vue';
import DialogAddress from '@/components/DialogAddress.vue';
import DialogAddressRegister from '@/components/DialogAddressRegister.vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import { capitalize } from '@/store/services/utils.js';
export default {
  name: 'AppBar',
  components: { 
    Menu,
    Search,
    Cart,
    Svgs,
    DialogAddress,
    DialogAddressRegister
  },
  data() {
    return {
      link: '',
      scrollPosition: 0,
      contadorCaracteres: 90,
      drawerMenu: false,
      drawerCarrinho: false,
      modelAddress: false,
      badge: false,
      tabs: null,
      startIsEntrega: null,
      startPage: "selecao",
      category_selected: 0,
      modelAddressRegister: false,
      address: null
    }
  },
  watch: {
    'getTotalCart': function (q) {
      this.badge = q > 0 ? true : false;
    },
    'getSelectedAddress.destiny_type': function(q){
      this.startIsEntrega = q;
    },
    "$route.params.id"(id) {
      this.category_selected = id;
    },
    "$route.name"() {
      this.link = this.$route['name'] == 'services' ? this.$route['params']['servico']: this.$route['name'];
    },
    "$route.params.servico"(link) {
      this.link = link;
    },
    'getAdjustAddresses': function (q) {
      if(q.length > 0){
        this.address = q[0];
        this.modelAddressRegister = true;
      }
    },
  },
  computed: {
    ...mapGetters('main', {
      getCategories: 'getCategories',
      getConfig: 'getConfig',
      getTabsClusterOffers: 'getTabsClusterOffers'
    }),
    ...mapGetters('cart', {
      getTotalCart: 'getTotalCart',
      getTotalValueCart: 'getTotalValueCart'
    }),
    ...mapState('cart', {
      loadingCart: 'loadingCart'
    }),
    ...mapState('user', {
      loadingUser: 'loadingUser'
    }),
    ...mapState('main', {
      loadingTabs: 'loadingTabs',
      logoImage: 'logoImage'
    }),
    ...mapGetters('user', {
      getUserInfo: 'getUserInfo',
      getSelectedAddress: 'getSelectedAddress',
      getAdjustAddresses: 'getAdjustAddresses'
    }),
  },
  methods: {
    ...mapActions('main', {
      getSubCategoriesMenu: 'getSubCategoriesMenu'
    }),
    ...mapActions('user', {
      logout: 'logout'
    }),
    capitalize,
    onScroll() {
      this.scrollPosition = window.top.scrollY;
    },
    checkLayout(){
      var val = window.innerWidth;
      if (parseFloat(val) >= 1800) {
          this.contadorCaracteres = 100;
      } else if (parseFloat(val) < 1800 && parseFloat(val) > 1500) {
          this.contadorCaracteres = 85;
      } else {
          this.contadorCaracteres = 70;
      }
    },
    openDialogAddress(){
      this.startPage = "horarios";
      this.modelAddress = true;
    },
    fechar: function(){
      this.modelAddress = false;
      this.startPage = "selecao";
    },
    fecharAddressRegister: function(){
      this.modelAddressRegister = false;
    },
    recolher: function(){
      this.drawerMenu = false;
      this.drawerCarrinho = false;
    },
    navDrawer(drawer){
      if(drawer == 'carrinho'){
        this.drawerMenu = false;
        this.drawerCarrinho = !this.drawerCarrinho;
      } else {
        this.drawerCarrinho = false;
        this.drawerMenu = !this.drawerMenu;
      }
    },
    logoutDialog(){
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja sair?", response: this.logoutAction});
    },
    logoutAction: function(r){
      if(r){
        this.logout().then(() => {
          this.$router.push('/');
        });
      }
    },
    openStores(){
      this.emitter.emit('dialogStores');
    },
    openLogin(){
      this.emitter.emit('dialogLogin');
    },
  },
  mounted(){
    this.link = this.$route['name'] == 'services' ? this.$route['params']['servico']: this.$route['name'];
    this.checkLayout();
    this.category_selected = this.$route['params']['id'];
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.checkLayout);
  },
  unmounted(){
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.checkLayout);
  }
};
</script>
